export const getDisplayableIndustries = (industries = []) => {
  return industries?.filter(i => i.industryValue?.toLowerCase() !== 'other');
};
